import { Routes } from '@angular/router';
import { ShellComponent } from './layouts/components/shell/shell.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
	{
		path: '',
		component: ShellComponent,
		canActivate: [authGuard],
		canActivateChild: [authGuard],
		children: [
			{
				path: '',
				pathMatch: 'full',
				redirectTo: 'cuentas'
			},
			{
				path: 'cuentas',
				loadChildren: () => import('./features/cuentas/cuentas.routes').then((m) => m.CUENTAS_ROUTES)
			},
			{
				path: 'detalle-consumo',
				loadChildren: () =>
					import('./features/detalle-consumo/detalle-consumo.routes').then((m) => m.DETALLE_CONSUMO_ROUTES)
			},
			{
				path: 'dashboard',
				loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES)
			}
		]
	},
	{
		path: 'login',
		loadComponent: () => import('./features/auth/login.page').then((m) => m.LoginPage)
	},
	{
		path: '**',
		redirectTo: 'login'
	}
];
